
<div class="modal-header" mat-dialog-title>
        <h5 class="modal-title">Action Log</h5>
        <a class="modal-close" mat-dialog-close>&#10005;</a>
    </div>
    <mat-dialog-content class="mat-add-image">
        <div class="modal-body">
            <div class="case-log-header">
                <ng-container>
                    <p><strong>Program:</strong> NGC</p>
                    <p><strong>Anatomic Site:</strong> {{dailogData.siteCode}}</p>
                    <p><strong>Diagnosis:</strong> {{dailogData.diagnosis}}</p>
                </ng-container>
            </div>
            <table class="table table-striped" aria-describedby="table">
                <tr>
                    <th id="action">Action</th>
                    <th id="date-tile">Last Updated Date/Time</th>
                    <th id="updatedby">Last Updated By</th>
                    <th id="imagepath">Image Path</th>
                    <th id="imageid">Image ID</th>
                    <th id="comment">Comment</th>
                </tr>
                <tbody>
                    <tr *ngFor="let logs of caseLogs">
                        <td>{{logs.actionCodeDesc}}</td>
                        <td>{{logs.lastUpdatedDate}}</td>
                        <td>{{logs.updatedUser}}</td>
                        <td>{{logs.imagePath}}</td>
                        <td>{{logs.imageId}}</td>
                        <td>{{logs.comment}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="mat-dialog-actions" align="start">
        <button mat-button mat-dialog-close class="save-btn">Close</button>
    </mat-dialog-actions>